import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput } from '../../../../Core/PathItems'
import { SearchSpeciesOutput, UpdateSpeciesThumbnailInput, AddBreedInput } from '../../../../PathItems'
import { CreateSpeciesInput, Species, UpdateSpeciesNameInput, UpdateSpeciesDescriptionInput, UpdateSpeciesUtilizesCommandsInput, UpdateSpeciesStateInput, UpdateSpeciesUsesLitterBoxInput, UpdateSpeciesIsIndoorOutdoorPetInput } from '../../PathItems'

export class SearchSpecies extends RequestOperation<SearchInput,SearchSpeciesOutput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.SearchSpecies",
      "SEARCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateSpecies extends RequestOperation<CreateSpeciesInput,Species> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.CreateSpecies",
      "CREATE",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetSpecies extends RequestOperation<object,Species> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.GetSpecies",
      "GET",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteSpecies extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.DeleteSpecies",
      "DELETE",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesName extends MessageOperation<UpdateSpeciesNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesName",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesDescription extends MessageOperation<UpdateSpeciesDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesDescription",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesThumbnail extends MessageOperation<UpdateSpeciesThumbnailInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesThumbnail",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesUtilizesCommands extends MessageOperation<UpdateSpeciesUtilizesCommandsInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUtilizesCommands",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesState extends MessageOperation<UpdateSpeciesStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesState",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class AddBreed extends MessageOperation<AddBreedInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.AddBreed",
      "ADD",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesUsesLitterBox extends MessageOperation<UpdateSpeciesUsesLitterBoxInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUsesLitterBox",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSpeciesIsIndoorOutdoorPet extends MessageOperation<UpdateSpeciesIsIndoorOutdoorPetInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesIsIndoorOutdoorPet",
      "PATCH",
      ["SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

